// import esriConfig from "@arcgis/core/config";
// import IdentityManager from "@arcgis/core/identity/IdentityManager";
// import ServerInfo from "@arcgis/core/identity/ServerInfo";
import Portal from "@arcgis/core/portal/Portal";
import config from "config";
import * as projection from "@arcgis/core/geometry/projection.js";
import slopeNoFormat from "utils/slopeNoFormat";
import MapSheet from "utils/MapSheet";

const PORTAL_ITEM_INFO_MAPPING = {
  LandsD3D: {
    category: "LandsD - 3D Spatial Dataset",
    layerType: "scene",
  },
  "LP Mesh": {
    category: "LandsD and PlanD - Photorealistic Mesh Model (by District)",
    layerType: "integ-mesh",
  },
  "BIM,Barrier": { category: "BIM Model", layerType: "bim", addtionalInfo: {} },
  Voxel: {
    category: "3D Geotechnical Model",
    layerType: "voxel",
  },
  "Mesh,SiteSpecific": {
    category: (layerInfo) => {
      let c = layerInfo.tags.find(
        (i) =>
          i === "t0:Man-made Feature" ||
          i === "t0:Landslide Incident" ||
          i === "t0:Others"
      );
      return c && c.substr(3);
    },
    layerType: "integ-mesh",
  },
  "PointCloud,SiteSpecific": {
    category: (layerInfo) => {
      let c = layerInfo.tags.find(
        (i) =>
          i === "t0:Man-made Feature" ||
          i === "t0:Landslide Incident" ||
          i === "t0:Others"
      );
      return c && c.substr(3);
    },
    layerType: "point-cloud",
  },
  "Drone,Mesh": {
    category: "UAV",
    layerType: "integ-mesh",
    addtionalInfo: {
      needLayerName: true,
    },
  },
  "Drone,PointCloud": {
    category: "UAV",
    layerType: "point-cloud",
    addtionalInfo: {
      needLayerName: true,
    },
  },
  "BIM,Tube,Tunnel": {
    category: "Tunnel",
    layerType: "bim",
  },
  "BIM,Tube": {
    category: "BIM Model",
    layerType: "bim",
  },
  "BIM,Tube,Voxel": {
    category: "3D Geotechnical Model",
    layerType: "bim",
  },
  "BIM,SiteSpecific,Tube": {
    category: (layerInfo) => {
      let c = layerInfo.tags.find(
        (i) =>
          i === "t0:Man-made Feature" ||
          i === "t0:Landslide Incident" ||
          i === "t0:Others"
      );
      return c && c.substr(3);
    },
    layerType: "bim",
  },
  // "BIM,SiteSpecific,Tube": {
  //   category: "Landslide Incident",
  //   layerType: "bim",
  // },
  // "BIM,SiteSpecific,Tube": {
  //   category: "Others",
  //   layerType: "bim",
  // },
  "BIM,Drone,Tube": {
    category: "UAV",
    layerType: "bim",
  },
  "3D Object,BIM,Tube": {
    category: "BIM Model",
    layerType: "scene",
  },
  "3D Object,Tube,Voxel": {
    category: "3D Geotechnical Model",
    layerType: "scene",
  },
  "3D Object,SiteSpecific,Tube": {
    category: (layerInfo) => {
      let c = layerInfo.tags.find(
        (i) =>
          i === "t0:Man-made Feature" ||
          i === "t0:Landslide Incident" ||
          i === "t0:Others"
      );
      return c && c.substr(3);
    },
    layerType: "scene",
  },
  // "3D Object,SiteSpecific,Tube": {
  //   category: "Landslide Incident",
  //   layerType: "scene",
  // },
  // "3D Object,SiteSpecific,Tube": {
  //   category: "Others",
  //   layerType: "scene",
  // },
  "3D Object,Drone,Tube": {
    category: "UAV",
    layerType: "scene",
  },
  "3D Object,Tube,Tunnel": {
    category: "Tunnel",
    layerType: "scene",
  },
};
class LoadPortalLayers {
  isLoaded = false;

  static async loadPortalLayers(categorys = [[`/Categories/3D GINFO`]], tags) {
    if (LoadPortalLayers.isLoaded) return;
    let portal = new Portal();
    await portal.load();
    await projection.load();
    if (typeof portal.user?.username === "undefined") {
      var err = new Error();
      err.cause = { httpCode: 403 };
      throw err;
    }
    console.log(portal.user?.username + " is now connected to the portal");
    let batchSize = 100;
    let itemResults = [];
    let queryParams = {
      query: ``,
      // sortField: "modified",
      // sortOrder: "desc",
      // filter: `${'(tags:("s:pa mei" OR "d:202110221129"))'}`,
      categories: categorys,
      start: 1,
      num: batchSize,
    };
    while (true) {
      let batchResults = await portal.queryItems(queryParams);
      itemResults.push.apply(itemResults, batchResults.results);
      if (batchResults.results.length === batchSize) {
        queryParams.start += batchSize;
        // queryParams = batchResults.nextQueryParams;
      } else break;
    }

    let layer3D = {};
    let ignoredCategories = ["3D GINFO", "ForBatchUpdateTags"];
    if (itemResults.length > 0) {
      console.log("itemResults", itemResults);
      itemResults.forEach((result) => {
        let categories = result.categories.reduce(
          (p, c, i) => (
            (i = c.substr(12)), !ignoredCategories.includes(i) && p.push(i), p
          ),
          []
        );
        categories = categories.sort().join(",");
        let mapping = PORTAL_ITEM_INFO_MAPPING[categories] || {};
        let { category, layerType, addtionalInfo } = mapping;
        if (typeof category === "function") category = category(result);
        if (categories === "BIM,Barrier") {
          if (result.type === "Image Service") {
            category = "bim_terrains";
            layerType = "terrain";
          }
        }
        if (categories === "Drone,Image") {
          let layerTitles = ["UAV Image Point", "UAV Flight Path"];
          for (let i = 0; i < layerTitles.length; i++) {
            let layerObj = this.assignLayers(
              "UAV",
              layer3D,
              result,
              "feature",
              {
                needUrl: true,
                title: layerTitles[i],
                layerId: i,
              }
            );
            layerObj.extent = undefined;
          }
        }
        if (categories === "Drone,Mesh" || categories === "Drone,PointCloud")
          addtionalInfo.layerName = result.title;
        !!category &&
          this.assignLayers(
            category,
            layer3D,
            result,
            layerType,
            addtionalInfo
          );
        if (!category) console.log("3D Layer not added", result, categories);
      });
      let bim_terrains = layer3D.bim_terrains || [];
      bim_terrains = bim_terrains.reduce(
        (p, c, i) => ((i = c.metaData?.slopeNo), (p[i] = c), p),
        {}
      );
      delete layer3D.bim_terrains;
      layer3D["BIM Model"].forEach(
        (i) =>
          i.metaData.slopeNo in bim_terrains &&
          (i.terrain = bim_terrains[i.metaData.slopeNo])
      );
      config.AvailLayerList.layer3D = layer3D;
      return layer3D;
    }
    LoadPortalLayers.isLoaded = true;
  }
  static assignLayers(groupName, layer3D, layer, layerType, special = {}) {
    if (!(groupName in layer3D)) layer3D[groupName] = [];

    let extent = null;
    if (layer.extent) {
      extent = projection.project(layer.extent, { wkid: 2326 });
    }

    let mapSheetNos = [];
    switch (groupName) {
      case "LandsD and PlanD - Photorealistic Mesh Model (by District)":
      case "LandsD - 3D Spatial Dataset":
        break;
      case "UAV":
        if (layer.title.substring(0, 3) === "UAV") break;
      default:
        mapSheetNos = MapSheet.filterKey(extent);
    }
    let metaData = {};
    try {
      let jsonText = layer.description;
      jsonText = jsonText.replace(/\&quot\;/g, '"');
      metaData = JSON.parse(jsonText);
      if (metaData.slopeNo) {
        let splitSlopNos = metaData.slopeNo.split(";");
        metaData.originSlopeNos = metaData.slopeNo;
        metaData.slopeNo = splitSlopNos.reduce(
          (p, c) => ((p[slopeNoFormat.FeatureNo13Char(c)] = 1), p),
          {}
        );
      }
    } catch {}

    var layerDescObj = {
      title: layer.title.replaceAll("_", " "),
      id: layer.id,
      type: layerType,
      tags: layer.tags,
      thumbnail: layer.thumbnail,
      createDate: new Date(layer.created).toLocaleDateString("en-HK"),
      mapSheetNos,
      extent,
      metaData,
    };
    if ("needUrl" in special && special.needUrl) {
      layerDescObj.title = special.title;
      layerDescObj.url = `${layer.url}/${special.layerId}`;
    } else if ("needLayerName" in special && special.needLayerName)
      layerDescObj.layerName = special.layerName;
    layer3D[groupName].push(layerDescObj);

    return layerDescObj;
  }
}
export { LoadPortalLayers };
